module.exports = __webpack_public_path__ + "fonts/Lato-Bold.5b1b8b85.ttf";